import React from 'react';

import { Linkedin02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useLinkedIn } from 'react-linkedin-login-oauth2';

import styles from './LinkedinButton.module.scss';

const LinkedinButton = () => {
  const { linkedInLogin } = useLinkedIn({
    clientId: '78s6flqajccq2v',
    redirectUri: `${process.env.REACT_APP_WEB_URL + '/assets/linkedin_callback.html'}`,
  });
  return (
    <div className={styles.linkedinBtn} onClick={linkedInLogin}>
      <HugeiconsIcon
        size="20"
        icon={Linkedin02Icon}
        strokeWidth="1.5"
        className="u-margin-bottom--tiny"
      />
      Continue with LinkedIn
    </div>
  );
};

export default LinkedinButton;
